/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { formatToBRL } from "../../../../utils/formatToMoney";
import EvidenceCell from "../components/evidence-cell";

import SortedCell from "../components/sorted-cell";

export const useColumns = ({ methods, isUploading, setIsUploading }: any) => {
  return [
    {
      accessorKey: "operator",
      header: "Operador",
      cell: ({ row }: { row: any }) => {
        return (
          <div className="w-full h-full px-[10px] py-[6px] bg-[#E6E6EB] text-[#74788D]">
            {row?.original?.operator}
          </div>
        );
      },
      className: "!p-0 !w-[342px]",
    },
    {
      accessorKey: "number",
      header: "Número",
      cell: ({ row }: { row: any }) => {
        return (
          <div className="w-full h-full px-[10px] py-[6px] bg-[#E6E6EB] text-[#74788D]">
            {row.original.number}
          </div>
        );
      },
      className: "!p-0 !w-[342px]",
    },
    {
      accessorKey: "amount",
      header: ({ column }: { column: any }) => (
        <SortedCell key={"amount"} column={column} title={"Valor"} />
      ),
      cell: ({ row }: { row: any }) => {
        return (
          <div className="w-full h-full px-[10px] py-[6px] bg-[#E6E6EB] text-[#74788D]">
            {formatToBRL(+row.original.amount)}
          </div>
        );
      },
      className: "!p-0 !w-[150px]",
    },
    {
      accessorKey: "evidence",
      header: "Evidência",
      cell: ({ row }: { row: any }) => {
        return <EvidenceCell
          row={row}
          entity_name="nsu"
          methods={methods}
          globalIsUploading={isUploading}
          setGlobalIsUploading={setIsUploading}
        />;
      },
      className: "!p-0 !w-[200px]",
    },
  ];
};
